import { Component, OnInit, Input, HostListener, ElementRef, ViewChild, ComponentFactoryResolver, Injector, ApplicationRef, EmbeddedViewRef, AfterViewChecked } from '@angular/core';
import { HelperService } from '../../../../../../services/helper/helper.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import swal from 'sweetalert2';
import { VideoLinkUploadModalComponent } from '../../../../../../shared/video-upload/video-link-upload-modal/video-link-upload-modal.component';
import { ViewVideoModalComponent } from '../../../../../../shared/view-video-modal/view-video-modal.component';
import { EventService } from '../../../../../../services/event/event.service';
@Component({
  selector: 'app-uploaded-file-view',
  templateUrl: './uploaded-file-view.component.html',
  styleUrls: ['./uploaded-file-view.component.css']
})
export class UploadedFileViewComponent implements OnInit {

  @ViewChild('toggleCommentBtn') public toggleCommentBtn: ElementRef;
  @Input() file = null;
  @Input() type = 'document';

  public commentVisible = false;

  private linkUploadModalInstance = null;
  private domElem = null;

  constructor(
    public helper: HelperService,
    private http: HttpClient,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    public event: EventService
  ) { }

  @HostListener('window:click', ['$event'])
  onWindowClick(event) {
    const commentPopover = event.path.find(elem => {
      return elem && elem.classList && elem.classList.contains('comment-popover')
        || (this.toggleCommentBtn && elem === this.toggleCommentBtn.nativeElement);
    });
    if (!commentPopover) {
      this.commentVisible = false;
    }
  }

  ngOnInit() {
  }

  getDownloadableName(file) {
    return file.title
      ? file.title + '.' + file.extension
      : file.name;
  }

  toggleComment(event) {
    this.commentVisible = !this.commentVisible;
  }

  showComment() {
    const title = this.file.title || this.file.name;
    swal({
      title,
      text: this.file.comment,
      customClass: 'swal-font-md'
    });
  }

  showVideo() {
    if (!this.linkUploadModalInstance) {
      const componentRef = this.componentFactoryResolver
        .resolveComponentFactory(ViewVideoModalComponent)
        .create(this.injector);
      this.appRef.attachView(componentRef.hostView);
      this.domElem = (componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;
      document.body.appendChild(this.domElem);
      this.linkUploadModalInstance = componentRef.instance;
    }
    if (this.linkUploadModalInstance) {
      this.linkUploadModalInstance.show(this.file);
    }
  }

  get linkUrl() {
    return this.file.url.startsWith('http')
      ? this.file.url
      : 'http://' + this.file.url;
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/shared/uploaded-file-view/uploaded-file-view.component.ts